import React from 'react'
import {
  LoginContainer,
  Subtitle,
  Description,
  CTA,
  TextSection,
  LoginImageSection,
  LoginButton,
  LoginImage,
  LoginImageOverlay,
  LogoWrapper,
  LoginErrorMessage,
} from './styled';
import { Logo } from '@unfold/logo';
import { useAppState } from '@unfold/provider';
import UnfoldProLogo from '../../assets/pro-logo.svg';

const Login: React.FC = () => {
  const [{ loginErrorMessage }, actions] = useAppState();

  return (
    <LoginContainer>
      <LogoWrapper>
        <Logo />
      </LogoWrapper>
      <TextSection>
        <UnfoldProLogo />
        <Subtitle>From Squarespace</Subtitle>
        <Description>Create brand-level content from everywhere.</Description>
        <LoginButton
          onClick={actions.login}
        >Log In</LoginButton>
        {loginErrorMessage.length > 0 && <LoginErrorMessage>{loginErrorMessage}</LoginErrorMessage>}
        <Description>Want to sign up?</Description>
        <CTA>Subscribe in the app</CTA>
      </TextSection>
      <LoginImageSection>
        <LoginImage />
        <LoginImageOverlay />
      </LoginImageSection>
    </LoginContainer>
  );

};

export default Login;
